<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-card>
        <b-form-group label="เลขร้องทุกข์" label-cols-md="3">
          <span
            class="row col-form-label"
            v-text="': ' + model.complaintCode"
          />
        </b-form-group>
        <b-form-group label="เลขเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.docCode" />
        </b-form-group>
        <b-form-group label="ประเภทเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.description" />
        </b-form-group>
        <b-form-group label="ประเภทเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.description" />
        </b-form-group>
        <b-form-group label="ผู้สร้างเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.createByName" />
        </b-form-group>
        <b-form-group label="หน่วยงาน" label-cols-md="3">
          <span
            class="row col-form-label"
            v-text="': ' + model.departmentName"
          />
        </b-form-group>
        <b-form-group label="ผู้สร้างเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.createByName" />
        </b-form-group>
        <b-form-group label="สถานะล่าสุด" label-cols-md="3">
          <span
            class="row col-form-label"
            v-text="': ' + model.docTrackingDescription"
          />
        </b-form-group>
        <b-form-group label="สถานะการอนุมัติเอกสาร" label-cols-md="3">
          <span
            class="row col-form-label"
            v-text="
              ': ' + (model.isSuccess !== undefined ? model.isSuccess : false)
            "
          />
        </b-form-group>
        <b-form-group label="สถานะการลบเอกสาร" label-cols-md="3">
          <span class="row col-form-label" v-text="': ' + model.isDelete" />
        </b-form-group>
        <b-form-group label="รายละเอียดเพิ่มเติม" label-cols-md="3">
          <a href="javascript:void(0)" @click="openDocument">ดูเอกสาร</a>
        </b-form-group>
      </b-card>
    </b-col>
    <b-col cols="4">
      <b-card>
        <b-row v-if="docHistoryDetail.length > 0">
          <b-col
            v-for="item in docHistoryDetail"
            :key="item.documentTracking.docTrackingId"
            cols="12"
            class="list-group list-group-circle text-left m-1"
          >
            <div class="d-flex list-group-item">
              <div class="">
                <h5 class="mb-0">
                  {{ item.documentTracking.createDateStr }} -
                  {{ item.tmMaster.description }}
                </h5>
                <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
              </div>
              <div class="col ml-auto">
                <hr class="my-12 bg-dark" />
              </div>
            </div>

            <div class="d-flex justify-content-between mb-1">
              <span class="mb-0">
                ดำเนินการโดย {{ item.users.titleStr }} {{ item.users.fName }}
                {{ item.users.lName }}
              </span>
              <small class="mb-0"></small>
            </div>

            <div class="d-flex justify-content-between ml-1">
              <span>
                ความคิดเห็น:
                {{
                  item.documentTracking.comment == null ||
                  item.documentTracking.comment == ""
                    ? "-"
                    : item.documentTracking.comment
                }}
              </span>
            </div>

            <div
              class="d-flex justify-content-between ml-1"
              v-if="item.documentTracking.fileName != null"
            >
              <span>
                <a
                  :href="item.documentTracking.filePath"
                  :download="item.documentTracking.fileName"
                  target="_blank"
                >
                  <b-icon
                    icon="star-fill"
                    animation="fade"
                    font-scale="4"
                  ></b-icon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-arrow-down-circle"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="8 12 12 16 16 12" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                  </svg>
                  {{ item.documentTracking.fileName }}
                </a>
              </span>
            </div>
          </b-col>
        </b-row>        

        <b-tabs class="mt-2">
          <b-tab id="tab-send-1" title="ยกเลิกเอกสาร">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form4">
                <ValidationProvider
                  rules="required"
                  name="รหัสยืนยัน"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="รหัสยืนยัน"
                    label-for="deletePin"
                    class="ml-1 mt-1"
                  >
                    <span class="text-danger">กรอกคำว่า ลบข้อมูล</span>
                    <b-form-input
                      id="deletePin"
                      placeholder="กรอกคำว่า ลบข้อมูล"
                      v-model="deletePin"
                      autocomplete="off"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button variant="danger" class="ml-1" @click="onDelete"
                >ยกเลิกเอกสาร</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-2" title="ลบประวัติเอกสาร">
            <div class="d-flex justify-content-end">
              <b-button
                variant="danger"
                class="ml-1"
                @click="onDeleteDocumentTracking"
                >ลบประวัติล่าสุด</b-button
              >
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BTab,
  BTabs,
} from "bootstrap-vue";
import LeftTab from "@/views/Complaint/components/LeftTabAction.vue";
import TrackingComplaint from "@/views/Complaint/components/TrackingComplaint/TrackingComplaint.vue";
import UpdateCommentModal from "./components/UpdateCommentModal.vue";
import VueSelect from "vue-select";

import * as documentManageStore from "@/store/api/document/document-manage";
import * as documentStore from "@/store/api/document/index.js";
import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BTab,
    BTabs,
    LeftTab,
    TrackingComplaint,
    UpdateCommentModal,
    VueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      model: {},
      docHistoryDetail: [],

      internalDep: null,
      internalDeps: [],
      comment: "",
      province: null,
      provinces: [],
      deletePin: "",
      officers: [],
      officer: null,
      channels: [],
      channel: null,
    };
  },
  mounted() {
    this.getDocumentById(this.$route.query.id);
    this.getDocHistory(this.$route.query.id);
  },
  methods: {
    onDeleteDocumentTracking() {
      this.onSubmitBtnClicked("UnStuckMyApproveState");
    },
    onSubmitBtnClicked(action) {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
            action,
            documentId: _this.$route.query.id,
            departmentId: userData.departmentId(),
            userId: userData.userId(),
            userFullName: userData.fullName(),
          };
          documentManageStore
            .updateData(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                _this.$router.go(_this.$router.currentRoute);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: response.data.message,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onDelete() {
      this.$refs.form4.validate().then((success) => {
        if (!success) {
          return;
        }

        const _this = this;

        this.$swal({
          title: "ยืนยันการลบข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (_this.deletePin !== "ลบข้อมูล") {
            _this.$bvToast.toast("กรุณากรอกรหัสยืนยันให้ถูกต้อง", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });

            return;
          }
          if (result.value) {
            const params = {
              action: "CancelDocument",
              documentId: _this.$route.query.id,
              departmentId: userData.departmentId(),
              userId: userData.userId(),
              userFullName: userData.fullName(),
            };
            documentManageStore
              .updateData(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  //_this.$router.push("ComplaintManage");
                  const routeData = this.$router.resolve({
                    name: "DocumentManage",
                  });
                  window.open(routeData.href, "_self");
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: response.data.message,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    getDocumentById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      documentManageStore
        .getById(id)
        .then(function(response) {
          // handle success

          console.log("getDocumentById", response);

          _this.model = response.data.data;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    getDocHistory(docId) {
      var _this = this;
      console.log("docId: ", docId);

      documentStore
        .GetHistoryDocument(docId)
        .then((response) => {
          //console.log("docHistoryDetail:", response.data.data);

          _this.docHistoryDetail = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    openDocument() {
      let redirectUrl =
        location.origin +
        this.$router.resolve({
          name: "DocumentManageEdit",
          query: { id: this.$route.query.id },
        }).href;
      let redirectBack =
        location.origin +
        this.$router.resolve({
          name: "DocumentManageEdit",
          query: { id: this.$route.query.id },
        }).href;

      let documentUrl = appsettings.documentUrlApprove
        .replace("{0}", this.$route.query.id)
        .replace("{1}", userData.userId())
        .replace("{2}", redirectUrl)
        .replace("{3}", redirectBack);

      //window.location.href = documentUrl;

      if (userData.isSecretary()) {
        documentUrl += "&isSecretary=1";
      }

      window.open(documentUrl, "_blank");
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
